import { cloneElement } from 'react';
import { useTranslation } from 'react-i18next';
import { PresenceTypeCategories } from '../../../../enums';
import { PresenceTypeCategoryModel } from '../../../../models/TimeAndAttendance';
import { resources } from '../../../../resources/resources';

export type Color = {
  id: number;
  colorName: string;
  bgColor: string;
  fgColor: string;
};

export const GetColors = (): Color[] => {
  const { t: translate } = useTranslation();
  return [
    {
      id: 1,
      colorName: translate(resources.admin.timesheetsSettings.dialog.colorRed),
      bgColor: 'FF5978',
      fgColor: 'FFFFFF',
    },
    {
      id: 2,
      colorName: translate(resources.admin.timesheetsSettings.dialog.colorBlue),
      bgColor: '1A6CE8',
      fgColor: 'FFFFFF',
    },
    {
      id: 3,
      colorName: translate(resources.admin.timesheetsSettings.dialog.colorBleu),
      bgColor: '0EB7FF',
      fgColor: 'FFFFFF',
    },
    {
      id: 4,
      colorName: translate(
        resources.admin.timesheetsSettings.dialog.colorTurquoise,
      ),
      bgColor: '4EBBC3',
      fgColor: 'FFFFFF',
    },
    {
      id: 6,
      colorName: translate(
        resources.admin.timesheetsSettings.dialog.colorGreen,
      ),
      bgColor: '81C105',
      fgColor: '4c4a4a',
    },
    {
      id: 7,
      colorName: translate(
        resources.admin.timesheetsSettings.dialog.colorYellow,
      ),
      bgColor: 'FFBD3D',
      fgColor: '4c4a4a',
    },
    {
      id: 8,
      colorName: translate(resources.admin.timesheetsSettings.dialog.colorGray),
      bgColor: '6C7786',
      fgColor: 'FFFFFF',
    },
  ] as Color[];
};

export const colorValueRender = (element: any, value: Color) => {
  if (!value) {
    return element;
  }
  const children = [
    <span
      className="attendance-colors-legend"
      key={1}
      style={{
        borderColor: `#${value.bgColor}`,
        //backgroundColor: `hsl(from #${value.bgColor} h s calc(l - 0.1))`,
        backgroundColor: `color-mix(in srgb, white 80%, #${value.bgColor})`,
      }}
    ></span>,
    <span key={2}>{element.props.children}</span>,
  ];
  return cloneElement(
    element,
    {
      ...element.props,
    },
    children,
  );
};

export const colorItemRender = (li: any, itemProps: any) => {
  const dataItem = itemProps.dataItem as Color;
  const itemChildren = (
    <span>
      <span
        className="attendance-colors-legend"
        style={{
          borderColor: `#${dataItem.bgColor}`,
          //backgroundColor: `hsl(from ${dataItem.bgColor} h s calc(l - 0.1))`,
          backgroundColor: `color-mix(in srgb, white 80%, #${dataItem.bgColor})`,
        }}
      ></span>
      <span>{li.props.children}</span>
    </span>
  );
  return cloneElement(li, li.props, itemChildren);
};

export const GetAttendanceTypeCategories = (): PresenceTypeCategoryModel[] => {
  const { t: translate } = useTranslation();
  return [
    {
      categoryId: PresenceTypeCategories.Work,
      description: translate(resources.admin.timesheetsSettings.dialog.work),
    },
    {
      categoryId: PresenceTypeCategories.Vacantion,
      description: translate(
        resources.admin.timesheetsSettings.dialog.vacantion,
      ),
    },
  ];
};
